import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
export default function ContactForm() {
  const [status, setStatus] = useState("idle");
  const [emailError, setEmailError] = useState("");
  const personalEmailDomains = [
    "gmail.com",
    "googlemail.com",
    "yahoo.com",
    "yahoo.co.uk",
    "hotmail.com",
    "hotmail.co.uk",
    "outlook.com",
    "live.com",
    "msn.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "aol.com",
    "protonmail.com",
    "proton.me",
    "gmx.com",
    "mail.com",
    "yandex.com",
  ];

  const isBusinessEmail = (email) => {
    const domain = email.split("@")[1]?.toLowerCase();

    if (!domain) return false;

    return !personalEmailDomains.includes(domain);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    const email = formData.get("email");

    if (!isBusinessEmail(email)) {
      setEmailError("Please enter your business email address.");
      return;
    }

    setEmailError("");
    setStatus("sending");

    try {
      const response = await fetch("https://formspree.io/f/xljdwyrr", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus("error");
    }
  };
  return (
    <div className="contact-form-wrapper">
      <div className="contact-form-header">
        <h2>Send us a message</h2>
        <p>
          Fill in the form below and a member of our team will get back to you.
        </p>
      </div>

      <Form className="contact-form" onSubmit={handleSubmit}>
        {" "}
        {/* Honeypot - hidden from real users, to prevent spam mails*/}
        <input
          type="text"
          name="_gotcha"
          className="honeypot"
          tabIndex="-1"
          autoComplete="off"
        />
        <Row>
          {" "}
          <Col md={6}>
            {" "}
            <Form.Group className="form-group">
              {" "}
              <Form.Label>First Name</Form.Label>{" "}
              <Form.Control
                type="text"
                name="first_name"
                placeholder="Enter your first name"
                required
              />{" "}
            </Form.Group>{" "}
          </Col>{" "}
          <Col md={6}>
            {" "}
            <Form.Group className="form-group">
              {" "}
              <Form.Label>Family Name</Form.Label>{" "}
              <Form.Control
                type="text"
                name="family_name"
                placeholder="Enter your family name"
                required
              />{" "}
            </Form.Group>{" "}
          </Col>{" "}
        </Row>{" "}
        <Row>
          {" "}
          <Col md={6}>
            {" "}
            <Form.Group className="form-group">
              <Form.Label>Business Email</Form.Label>

              <Form.Control
                type="email"
                name="email"
                placeholder="name@company.com"
                required
                isInvalid={!!emailError}
                onChange={(e) => {
                  const email = e.target.value;

                  if (email && !isBusinessEmail(email)) {
                    setEmailError("Please enter your business email address.");
                  } else {
                    setEmailError("");
                  }
                }}
              />

              <Form.Control.Feedback type="invalid">
                {emailError}
              </Form.Control.Feedback>
            </Form.Group>{" "}
          </Col>{" "}
          <Col md={6}>
            {" "}
            <Form.Group className="form-group">
              {" "}
              <Form.Label>Organization Name</Form.Label>{" "}
              <Form.Control
                type="text"
                name="organization"
                placeholder="Your organization"
                required
              />{" "}
            </Form.Group>{" "}
          </Col>{" "}
        </Row>{" "}
        <Form.Group className="form-group">
          {" "}
          <Form.Label>Title</Form.Label>{" "}
          <Form.Control
            type="text"
            name="title"
            placeholder="Your job title"
            required
          />{" "}
        </Form.Group>{" "}
        <Form.Group className="form-group">
          {" "}
          <Form.Label>Subject</Form.Label>{" "}
          <Form.Control
            type="text"
            name="subject"
            placeholder="What would you like to discuss?"
            required
          />{" "}
        </Form.Group>{" "}
        <Form.Group className="form-group">
          {" "}
          <Form.Label>Message</Form.Label>{" "}
          <Form.Control
            as="textarea"
            rows={6}
            name="message"
            placeholder="Write your message..."
            required
          />{" "}
        </Form.Group>{" "}
        {/* Success message */}{" "}
        {status === "success" && (
          <div className="form-message form-message--success">
            {" "}
            Thank you for contacting us. Your message has been sent
            successfully.{" "}
          </div>
        )}{" "}
        {/* Error message */}{" "}
        {status === "error" && (
          <div className="form-message form-message--error">
            {" "}
            Something went wrong. Please try again later.{" "}
          </div>
        )}{" "}
        <Button
          type="submit"
          className="contact-submit"
          disabled={status === "sending"}
        >
          {" "}
          {status === "sending" ? "Sending..." : "Send Message"}{" "}
          {status !== "sending" && <FaPaperPlane />}{" "}
        </Button>{" "}
      </Form>
    </div>
  );
}
